<template>
  <section>
    <v-card class="ui-module-card ui-module-fade-in-up mb-4" color="primary">
      <v-card-text>
        <v-row justify="space-between">
          <v-col cols="8">
            <h3 class="font-weight-bold mb-2">{{ rubro.title }}</h3>
            <p>{{ rubro.objetivo }}</p>
          </v-col>
          <v-col cols="auto">
            <v-chip :color="resultado === RESULTADOS.INSATISFACTORIO ? 'error' : 'success'" text-color="white">
              {{ resultado }}
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
      <hr />
      <v-card-text>
        <v-row v-for="reactivo in reactivosOfRubro" :key="reactivo.id" align="center">
          <v-col cols="8">
            <p class="text-subtitle-1">{{ reactivo.descripcion }}</p>
          </v-col>
          <v-col cols="4">
            <BaseSelect label="Calificación" v-model="reactivo.calificacion" :items="frecuencias" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import BaseSelect from '@/components/base/BaseSelect.vue'
import { RESULTADOS } from '@/modules/evaluacion-anual/domain/RESULTADOS'
import { TIPOS_EVALUACION_ANUAL } from '@/modules/evaluacion-anual/domain/TIPOS_EVALUACION_ANUAL'

const PUNTAJE_CALIFICACION = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
}

export default {
  components: { BaseSelect },

  props: {
    rubro: {
      type: Object,
      required: true,
    },

    reactivos: {
      type: Array,
      required: true,
    },

    frecuencias: {
      type: Array,
      required: true,
    },

    tipoEvaluacion: {
      type: Number,
      default: TIPOS_EVALUACION_ANUAL.EVACOM,
    },
  },

  data() {
    return {
      RESULTADOS,
    }
  },

  computed: {
    reactivosOfRubro() {
      return this.reactivos.filter(({ idRubro }) => idRubro === this.rubro.id)
    },

    puntaje() {
      let total = 0

      this.reactivosOfRubro.forEach((reactivo) => {
        total += PUNTAJE_CALIFICACION[reactivo.calificacion] ?? 0
      })

      return total
    },

    resultado() {
      if (this.tipoEvaluacion === TIPOS_EVALUACION_ANUAL.EVACOM) {
        if (this.puntaje >= 31.5 && this.puntaje <= 35) {
          return RESULTADOS.EXCELENTE
        }

        if (this.puntaje >= 24.5 && this.puntaje <= 31.4) {
          return RESULTADOS.SATISFACTORIO
        }

        return RESULTADOS.INSATISFACTORIO
      }

      if (this.puntaje >= 22.5 && this.puntaje <= 25) {
        return RESULTADOS.EXCELENTE
      }

      if (this.puntaje >= 17.5 && this.puntaje <= 22.4) {
        return RESULTADOS.SATISFACTORIO
      }

      return RESULTADOS.INSATISFACTORIO
    },
  },
}
</script>

<style scoped>
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* Textos del card — evitar negro del tema claro */
h3,
p,
::v-deep .text-subtitle-1 {
  color: #e0e0e0 !important;
}

/* Cards internas */
::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
}

hr {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}
</style>
